import { useMemo } from "react";
import { Area, AreaChart, ResponsiveContainer } from "recharts";
import styles from "./SummaryPerformanceChart.module.css";

const PLACEHOLDER_TREND = [
  { name: "1", value: 22 },
  { name: "2", value: 30 },
  { name: "3", value: 38 },
  { name: "4", value: 46 },
  { name: "5", value: 54 },
  { name: "6", value: 62 },
];

const buildChartData = (strategies = []) => {
  if (strategies.length >= 2) {
    let running = 0;
    const points = strategies.map((strategy, index) => {
      running += Number(strategy.pnl) || 0;
      return {
        name: String(index + 1),
        value: Math.abs(running),
      };
    });

    return points.length > 6 ? points.slice(points.length - 6) : points;
  }

  if (strategies.length === 1) {
    const value = Math.abs(Number(strategies[0].pnl) || 0);
    const base = Math.max(value * 0.55, 12);
    return [
      { name: "1", value: base },
      { name: "2", value: base * 1.15 },
      { name: "3", value: base * 1.3 },
      { name: "4", value: base * 1.45 },
      { name: "5", value: base * 1.6 },
      { name: "6", value: Math.max(value, base * 1.75) },
    ];
  }

  return PLACEHOLDER_TREND;
};

function SummaryPerformanceChart({ strategies = [], isPositive = true }) {
  const chartData = useMemo(() => buildChartData(strategies), [strategies]);
  const strokeColor = isPositive ? "#48a77f" : "#ef4444";
  const gradientId = isPositive ? "summaryPerfGreen" : "summaryPerfRed";

  return (
    <div
      className={styles.chartWrap}
      aria-hidden
      role="img"
      aria-label="Performance trend chart"
    >
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 2, right: 2, left: 2, bottom: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={strokeColor} stopOpacity={0.45} />
              <stop offset="100%" stopColor={strokeColor} stopOpacity={0.04} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="value"
            stroke={strokeColor}
            strokeWidth={2}
            fill={`url(#${gradientId})`}
            dot={false}
            activeDot={false}
            isAnimationActive
            animationDuration={700}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default SummaryPerformanceChart;
